import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import "./AdminDashboard.css";
import Navigation from "./Navigation";
import Error from "./Error";

import { fetchStudents, fetchUser, userRoles } from "../api/user-service";
import { 
    Box, 
    Typography,
    List,
    ListItem,
    CircularProgress
 } from "@mui/material";
 import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const listStyle = {
    height: '60vh',
    width: {
        xs: '10rem',
        md: '15rem',
    },
    backgroundColor: 'rgba(255, 255, 255, 0.8)', 
    padding: 2, 
    marginTop: 2, 
    border: '2px solid #e0dfda',
    boxShadow: '0 0 10px #e0dfda',
    overflow: 'scroll'
}

const AdminDashboard = () => {
    const [students, setStudents] = useState([]);
    const [user, setUser] = useState({});
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Get students
        fetchStudents()
        .then(students => {
            setStudents(students)
            setIsLoading(false);
        },
        error => setError(error.message));

        // Get user
        fetchUser().then(user => {
            setUser(user)
            setIsLoading(false);
        },
        error => {
            setIsLoading(false);
            setError(error.message)
        });
    }, []);

    if (error) {
        return <Error message={error} />
    }

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <CircularProgress></CircularProgress>
            </Box>
        )
    }

    if (user.role !== userRoles.ADMIN) {
        return (
            <Box>
                <Typography variant="h5">You are not authorized to view this page. Go to <a href="/login">homepage</a>.</Typography>
            </Box>
        )
    } 


    return (
        <Box sx={{marginLeft: 4}}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', marginBottom: 2}}>
                <Typography variant="h5">Hello, {user.username}!</Typography>
                <Navigation />
            </Box>
            <Typography variant="h6">Check out participants activities</Typography>
            {!students.length ? <Typography>No students found.</Typography> : (
                <List sx={listStyle}>
                    {students.map((student) => (
                        <ListItem key={student.id} sx={{zIndex: 2}}>
                            <Link to={student.id} state = {{studentUsername: student.username}} className="student-link"
                            >
                                <AccountCircleIcon sx={{marginRight: 1}}/>
                                <Typography>{student.username}</Typography>
                            </Link>
                        </ListItem>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default AdminDashboard;